// main
import "../sass/main.scss";
import "./modules/header.js";

console.log('in main');